import { ProgramService } from "@adfenix/types";
import Sentry from "lib/sentry/init";
import { useFormContext } from "react-hook-form";
import { getBundleKey } from "./campaign/util/formKey";

interface Props {
  bundleIndex: number;
  bundleGroupIndex: number;
}

export const useNestedFormData = ({ bundleIndex, bundleGroupIndex }: Props) => {
  const { watch } = useFormContext<ProgramService.ProgramModel>();
  const programData = watch();
  const bundleGroup = programData?.bundleGroups?.[bundleGroupIndex];
  const bundle = bundleGroup?.bundles?.[bundleIndex];
  const bundleKey = getBundleKey(bundleGroupIndex, bundleIndex);

  if (!bundleGroup || !bundle) {
    Sentry.captureException(
      "useNestedProgramFormDataWithoutCampaign was called in an unexpected state",
      {
        extra: {
          formData: JSON.stringify(programData)
        }
      }
    );
    throw new Error();
  }

  return {
    bundleGroup,
    bundle,
    bundleKey
  };
};
